import React from 'react';

const MatchbackStepArrowIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.33325 13.3334L11.6666 10L8.33325 6.66669"
        stroke="#ABABAB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MatchbackStepArrowIcon;
